import { DashboardCustomize } from '@mui/icons-material';
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface dashboardState {
  data: [] | null;
  graphData:[]| null;
  cityWiseData:[]|null;
  parkingWiseData:[]|null;
}

const initialState: dashboardState = {
  data: null,
  graphData:null,
  cityWiseData:null,
  parkingWiseData:null
};

export const dashboardSlice = createSlice({
  name: 'dashboardData',
  initialState,
  reducers: {
    setDashboardDataStore: (state, action) => {
      state.data = action.payload;
      state.graphData=action.payload.graphData
      state.cityWiseData=action.payload.cityWiseData
      state.parkingWiseData=action.payload.parkingWiseData


    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const { setDashboardDataStore, reset } = dashboardSlice.actions;

export const getDashboardDataStore = (state: any) => state.dashboard.data;
export const getDashboardgraphDataStore = (state: any) => state.dashboard.graphData;
export const getDashboardcityWiseDataStore = (state: any) => state.dashboard.cityWiseData;
export const getDashboardparkingWiseDataStor = (state: any) => state.dashboard.parkingWiseData;





export default dashboardSlice.reducer;
